import * as React from "react";
import { Image } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { Link } from "@ludens-reklame/rubics-v3-sdk/link/types";
import {
  Constrainer,
  HorizontalSpacer,
  VerticalSpacer,
} from "../../internal-components/Layout.js";
import { useImageProps } from "../../hooks/useImageProps.js";
import { createLinkProps } from "../../hooks/useLinkProps.js";
import { chevron } from "../../icons/index.js";
import type { BackgroundColor } from "../../types/theme.js";
import {
  HeroLogoCard,
  HeroLogoMedia,
  HeroLogoContent,
  HeroLogoTitle,
  HeroLogoText,
  HeroLogoLinks,
  HeroLogoLink,
} from "./styles.js";

export interface HeroLogoLinkItem {
  link?: Link;
}

export interface Props {
  logo?: Image;
  title?: string;
  text?: string;
  links?: HeroLogoLinkItem[];
  backgroundColor?: BackgroundColor;
}

export const HeroLogo: React.FC<Props> = ({
  logo,
  title,
  text,
  links = [],
  backgroundColor,
}) => {
  const logoProps = useImageProps(logo, { width: 1200 });
  const validLinks = links.filter((item) => item.link?.url);

  if (!logoProps && !title && !text && validLinks.length === 0) return null;

  return (
    <VerticalSpacer>
      <HorizontalSpacer>
        <Constrainer>
          <HeroLogoCard $bg={backgroundColor}>
            {logoProps && (
              <HeroLogoMedia>
                <img {...logoProps} />
              </HeroLogoMedia>
            )}
            <HeroLogoContent>
              {title && <HeroLogoTitle>{title}</HeroLogoTitle>}
              {text && <HeroLogoText>{text}</HeroLogoText>}
              {validLinks.length > 0 && (
                <HeroLogoLinks>
                  {validLinks.map((item, i) => (
                    <HeroLogoLink key={i} {...createLinkProps(item.link!)}>
                      {chevron}
                      <span>{item.link!.title}</span>
                    </HeroLogoLink>
                  ))}
                </HeroLogoLinks>
              )}
            </HeroLogoContent>
          </HeroLogoCard>
        </Constrainer>
      </HorizontalSpacer>
    </VerticalSpacer>
  );
};
